import { render } from "./IframeEducation.vue?vue&type=template&id=2e975f97&scoped=true"
import script from "./IframeEducation.vue?vue&type=script&lang=js"
export * from "./IframeEducation.vue?vue&type=script&lang=js"

import "./IframeEducation.vue?vue&type=style&index=0&id=2e975f97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e975f97"]])

export default __exports__